(() => {
  const threshold = 20000;
  let timer;
  let syncing = false;
  const installRecommendations = () => document.querySelectorAll('.bevanup-cart-recommendations__image').forEach(image => {
    if (image.dataset.bevanupReady === 'true' || !image.querySelector('.bevanup-cart-recommendations__media--secondary')) return;
    image.dataset.bevanupReady = 'true';
    image.addEventListener('click', event => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const card = image.closest('.bevanup-cart-recommendations__card');
      if (!image.classList.contains('is-secondary')) { event.preventDefault(); image.classList.add('is-secondary'); card?.classList.add('is-interacting'); }
    });
  });
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const ensureShipping = cart => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    let shipping = drawer.querySelector('.bevanup-cart-shipping');
    if (!cart.item_count) { shipping?.remove(); return; }
    if (!shipping) {
      shipping = document.createElement('div'); shipping.className = 'bevanup-cart-shipping';
      const copy = document.createElement('p');
      const track = document.createElement('div'); track.className = 'bevanup-cart-shipping__track';
      const fill = document.createElement('span'); track.append(fill);
      const reward = document.createElement('div'); reward.className = 'bevanup-cart-shipping__reward'; reward.setAttribute('aria-label', 'Free Shipping');
      reward.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M3 5.5h11v11H3zM14 9h3.6L21 12.4v4.1h-7z" stroke="currentColor" stroke-width="1.5"/><circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.5"/><circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.5"/><path d="M6.5 8.5v3m4-3v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><small>FREE<br>SHIPPING</small>';
      shipping.append(copy, track, reward);
      const content = drawer.querySelector('.cart-drawer__content');
      const header = drawer.querySelector('.theme-drawer__header');
      if (content) content.parentElement.insertBefore(shipping, content); else if (header) header.insertAdjacentElement('afterend', shipping);
    }
    const remaining = Math.max(0, threshold - cart.total_price);
    shipping.dataset.cartTotal = String(cart.total_price);
    shipping.dataset.freeShippingThreshold = String(threshold);
    shipping.querySelector('p').textContent = remaining ? money(remaining) + ' away from free shipping' : 'Free shipping unlocked';
    shipping.querySelector('.bevanup-cart-shipping__track span').style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
  };
  const syncShipping = async () => {
    if (syncing) return; syncing = true;
    try { const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); if (response.ok) ensureShipping(await response.json()); }
    catch (_) { /* Preserve the server-rendered state on a transient request failure. */ }
    finally { syncing = false; }
  };
  const schedule = () => { window.clearTimeout(timer); timer = window.setTimeout(() => { installRecommendations(); syncShipping(); }, 80); };
  installRecommendations(); syncShipping();
  document.addEventListener('shopify:section:load', schedule);
  ['cart:updated', 'cart:update', 'cart:change'].forEach(event => document.addEventListener(event, schedule));
  new MutationObserver(records => {
    if (records.some(record => record.target.closest?.('cart-drawer-component') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('cart-drawer-component, .theme-drawer__dialog') || node.querySelector?.('cart-drawer-component'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
})();